export enum BillSource {
  BOL,
  SHIPMENT
}
